import * as React from "react";

/**
 * Read-only detail vocabulary, ported from ScadsysIdentity's DetailField / DetailSection /
 * EmptyDetail (dataMaintenance/DataMaintenanceIndex.tsx).
 */

export const DetailSection: React.FC<{ title: string; children: React.ReactNode; className?: string }> = ({
    title,
    children,
    className = "",
}) => (
    <section className={`mb-6 ${className}`}>
        <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-weak">{title}</h4>
        <div className="grid gap-3 sm:grid-cols-2">{children}</div>
    </section>
);

export const DetailField: React.FC<{ label: React.ReactNode; children?: React.ReactNode; mono?: boolean }> = ({ label, children, mono }) => (
    <div className="min-w-0">
        <div className="text-xs text-text-weak">{label}</div>
        <div className={`break-words text-sm text-text ${mono ? "font-mono text-xs" : ""}`}>
            {children === null || children === undefined || children === "" ? <span className="text-text-weak">&mdash;</span> : children}
        </div>
    </div>
);

export const EmptyDetail: React.FC<{ children?: React.ReactNode }> = ({ children = "Nothing to show." }) => (
    <p className="py-6 text-center text-sm text-text-weak">{children}</p>
);

/**
 * A ULID rendered for a human: shortened, monospaced, with the full value on hover. IDs in this
 * system are 26-character ULIDs, so showing one raw in a table blows the column out.
 */
export const IdBadge: React.FC<{ id?: string | null }> = ({ id }) => {
    if (!id) return <span className="text-text-weak">&mdash;</span>;

    const short = id.length > 10 ? id.slice(0, 6) + "…" + id.slice(-4) : id;

    return (
        <span title={id} className="font-mono text-xs text-text-weak">
            {short}
        </span>
    );
};
